import { HttpBackend } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { CfgService } from '../../../../cfg/cfg.service';
import { ServerAddressesCfgService } from 'src/app/util/serverAddressesCfg.service';

export class ExpiringContractsDirectCfg {
  public summaryEndpointPattern: string;
  public detailEndpointPattern: string;
}

export class UnsignedContractsDirectCfg {
  public summaryEndpointPattern: string;
  public detailEndpointPattern: string;
}

export class ContractsDirectKpiCfg {
  public expiringContractsDirect: ExpiringContractsDirectCfg;
  public unsignedContractsDirect: UnsignedContractsDirectCfg;
}

@Injectable()
export class ContractsDirectKpiCfgService extends CfgService<ContractsDirectKpiCfg> {
  json: any = {
    expiringContractsDirect: {
      summaryEndpointPattern: "%{DashboardDirectApiUrl}/contracts/{0}/expiring?beginDate={1}&endDate={2}",
      detailEndpointPattern: "%{DashboardDirectApiUrl}/contracts/{0}/expiring/detail?beginDate={1}&endDate={2}"
    },
    unsignedContractsDirect: {
      summaryEndpointPattern: "%{DashboardDirectApiUrl}/contracts/{0}/unsigned?beginDate={1}&endDate={2}",
      detailEndpointPattern: "%{DashboardDirectApiUrl}/contracts/{0}/unsigned/detail?beginDate={1}&endDate={2}"
    }
  }

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/kpi/contractsDirectKpi.cfg.json`;
  }

  /**
* Carga las url en el json
*/
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
